import { useNavigate } from 'react-router-dom';

import Box from 'components/shared/Box/Box';
import Button from 'components/shared/Buttons/Button';
import { withErrorBoundary } from 'components/shared/Error/Boundary';

const LatestResults = ({ title, latestResults }) => {
  const navigate = useNavigate();
  return (
    <Box className="flex flex-col gap-4">
      <span className="text-xl font-500 text-neutral-900">{title}</span>
      {latestResults.number_unread > 0 ? (
        <div className="flex flex-col gap-2">
          <span>{latestResults.number_unread}</span>
          <span>You have new results</span>
        </div>
      ) : (
        <p className="text-sm text-neutral-700">There are no new results published at this time!</p>
      )}
      <Button
        className="mt-auto"
        text="See all results"
        onClick={() =>
          navigate(`/myportal/${latestResults.number_unread > 0 ? 'inbox' : 'medical-records'}`)
        }
      />
    </Box>
  );
};

export default withErrorBoundary(LatestResults);
